import Header from "../layout/Header";
import Footer from "../layout/Footer";
import { useSEO } from "../hooks/useSEO";

export default function WhyVastavik() {
  useSEO({
    title: "Why Vastavik — Stop Deepfakes & Prove Your Media is Real",
    description:
      "Celebrities, journalists, politicians and creators use Vastavik to prove their photos, videos and audio are real — not AI-generated or deepfaked. If it's not on Vastavik, don't trust it.",
    path: "/whyvastavik",
    keywords: "why Vastavik, stop deepfakes, prove media is real, celebrity deepfake protection, journalist media verification, deepfake prevention for creators, blockchain authenticity",
  });
  return (
    <div className="min-h-screen bg-white flex flex-col text-black">
      {/* Header */}
      <Header />

      {/* Content */}
      <main
        className="flex-1 overflow-y-auto px-6 md:px-10 pt-16 pb-20"
        style={{
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <div className="w-full max-w-[760px] mx-auto">
          {/* Title */}
          <h1
            className="
              font-caviar
              font-bold
              text-[40px]
              leading-none
              tracking-[-0.005em]
              text-black
              mb-10
            "
          >
            Why Vastavik ?
          </h1>

          {/* Content */}
          <div className="space-y-8">
            <p
              className="
                font-productsans
                font-light
                text-[20px]
                leading-[1.45]
                tracking-[-0.005em]
                text-black/75
              "
            >
              Vastavik is designed to address the growing challenges posed by
              DeepFakes. Users who want to protect their media or establish
              trust in the authenticity of their content in the public domain
              can use Vastavik as their authenticity marker.
            </p>

            <p
              className="
                font-productsans
                font-light
                text-[20px]
                leading-[1.45]
                tracking-[-0.005em]
                text-[#d33]
              "
            >
              With Vastavik, users can clearly state: “If it’s not verified
              through Vastavik, do not trust the media as authentic or endorsed
              by me.”
            </p>

            <p
              className="
                font-productsans
                font-light
                text-[20px]
                leading-[1.45]
                tracking-[-0.005em]
                text-black/75
              "
            >
              Vastavik provides users significant peace of mind, freeing them
              from the constant need to explain which media is authentic and
              which is not.
            </p>

            <p
              className="
                font-productsans
                font-light
                text-[20px]
                leading-[1.45]
                tracking-[-0.005em]
                text-black/75
              "
            >
              Vastavik’s uniqueness lies in its core principle: “what’s on
              Vastavik is true and authentic—and the same cannot be said for
              everything else out there.”
            </p>

            {/* Section */}
            <div className="pt-4">
              <h2
                className="
                  font-caviar
                  font-bold
                  text-[32px]
                  leading-none
                  tracking-[-0.005em]
                  text-black
                  mb-6
                "
              >
                Who is Vastavik for?
              </h2>

              <p
                className="
                  font-productsans
                  font-light
                  text-[20px]
                  leading-[1.45]
                  tracking-[-0.005em]
                  text-black/75
                "
              >
                Vastavik is designed for those whose media—such as videos,
                photos, or audio—could be manipulated to create deepfakes that
                may harm them or others. It is especially valuable for
                individuals and groups who are frequent targets of
                misinformation, including celebrities, politicians, social media
                creators, institutions, and journalists.
              </p>
            </div>

            {/* Section */}
            <div className="pt-4">
              <h2
                className="
                  font-caviar
                  font-bold
                  text-[32px]
                  leading-none
                  tracking-[-0.005em]
                  text-black
                  mb-6
                "
              >
                How Vastavik is Unique ?
              </h2>

              <p
                className="
                  font-productsans
                  font-light
                  text-[20px]
                  leading-[1.45]
                  tracking-[-0.005em]
                  text-black/75
                  mb-8
                "
              >
                Vastavik is designed to serve as a trusted single source of
                truth for the public. It leverages Hyperledger Fabric blockchain
                and NFT-based technology to ensure uncompromising authenticity
                and security. Once a piece of media is registered on the
                blockchain, even the original user cannot dispute its existence
                or remove it unless a formal request is submitted.
              </p>

              <p
                className="
                  font-productsans
                  font-light
                  text-[20px]
                  leading-[1.45]
                  tracking-[-0.005em]
                  text-black/75
                "
              >
                By default, users can register their media as a private NFT,
                ensuring controlled visibility. Those who wish to make their
                verification publicly accessible can opt for a public NFT at an
                additional cost.
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}